import React from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import LaneRatesEditor from './LaneRatesEditor';

function isAddAction(location) {
  return location.pathname.includes('add');
}

export default function LaneRatesEditPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const { id } = useParams();

  const isActionCreate = isAddAction(location);
  const breadcrumbs = {
    pages: [
      {
        name: t('LANE_RATES'),
        href: '/lane-rates',
        current: false,
      },
      {
        name: isActionCreate ? t('ADD_LANE_RATE') : t('EDIT_LANE_RATES'),
        current: true,
      },
    ],
  };

  return (
    <main className="py-4">
      <LayoutWithSidebar title={t('LANE_RATES')} breadcrumbs={breadcrumbs}>
        <LaneRatesEditor
          laneRateId={id}
          laneRates={location.state?.laneRates}
          isActionCreate={isActionCreate}
        />
      </LayoutWithSidebar>
    </main>
  );
}
